import { defineStore } from 'pinia';

export const useErrorStore = defineStore('errorStore', {
    state: () =>
    ({
        errorCode: 0,
        errorMessage: undefined as string | undefined,
        errorDetails: undefined as string | undefined
    }),
    actions:
    {
        setError(e: { message?: string; statusCode?: number; details?: string; error?: string } | undefined): void
        {
            if(e)
            {
                let errorMessage = e.message || e.error || JSON.stringify(e);

                // Suppress Bad Gateway error until Sysops fix the root cause.
                if(e.statusCode === 502) return;

                if(e.statusCode === 403 || e.statusCode === 422 || (e.statusCode === 400 && e.message === 'jwt expired'))
                {
                    if(e.message === 'Forbidden' || e.message === 'jwt expired') errorMessage = 'Your session has expired.'
                }

                if(errorMessage === 'popup_closed_by_user')
                {
                    errorMessage = 'Could not successfully authenticate with Google because the popup window was closed. Please disable popup blockers or privacy browser extensions and try again.'
                }

                //When a user does not have an account, multiple errors will be generated.
                //Ignore all errors if the current error indicates the user does not have an account.
                if(this.errorMessage?.indexOf('Your account could not be found') === 0)
                {
                    return;
                }

                // make 5xx errors prettier 
                if(`${e.statusCode}`.startsWith('5'))
                {
                    errorMessage = "Could not fulfill your request at this moment. Please try again.";
                }

                this.errorCode = e.statusCode;
                this.errorMessage = errorMessage;
                this.errorDetails = e.details;
            }
            else
            {
                this.errorCode = 0;
                this.errorMessage = undefined;
                this.errorDetails = undefined;
            }
        },
        resetError(): void
        {
            this.setError(undefined);
        }
    }
});